import { supabase } from "@/services";
import { useEffect } from "react";

export default function useHashSessionManager(onSessionError?: () => void) {
  // Handle hash fragment parsing
  const handleHashFragment = async () => {
    if (window.location.hash) {
      const hashParams = new URLSearchParams(
        window.location.hash.substring(1), // Remove the # character
      );

      const accessToken = hashParams.get("access_token");
      const refreshToken = hashParams.get("refresh_token");

      if (accessToken && refreshToken) {
        try {
          const { error } = await supabase.auth.setSession({
            access_token: accessToken,
            refresh_token: refreshToken,
          });

          if (error) throw error;
          // Clean up the URL
          window.history.replaceState(null, "", window.location.pathname);
        } catch (error) {
          console.error("Error setting session:", error);
          if (onSessionError) {
            onSessionError();
          }
        }
      }
    } else {
      if (onSessionError) {
        onSessionError();
      }
    }
  };
  useEffect(() => {
    handleHashFragment();
  }, []);
}
